module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/banner-tablet-3a1705304f59673a34492eb02aba9a53.svg";